var article = {
  "fields": {
    "id": {
      "name": "id",
      "type": "ID",
      "readonly": 3,
      "options": null
    },
    "label": {
      "name": "label",
      "type": "ENUM",
      "readonly": false,
      "options": ["Blog", "Ad", "GamingTopic", "OffTopic", "News", "Article", "Podcast", "Document"]
    },
    "status": {
      "name": "status",
      "type": "BOOL",
      "readonly": false,
      "options": null
    },
    "publishDate": {
      "name": "publishDate",
      "type": "DATETIME",
      "readonly": false,
      "options": null
    },
    "feed": {
      "name": "feed",
      "type": "BOOL",
      "readonly": false,
      "options": null
    },
    "authorId": {
      "name": "authorId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "permalink": {
      "name": "permalink",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "title": {
      "name": "title",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "lead": {
      "name": "lead",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "body": {
      "name": "body",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "icon": {
      "name": "icon",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "iconColor": {
      "name": "iconColor",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "metaKeywords": {
      "name": "metaKeywords",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "metaDescription": {
      "name": "metaDescription",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "comment_status": {
      "name": "comment_status",
      "type": "ENUM",
      "readonly": false,
      "options": ["open", "closed", "hidden"]
    },
    "comment_lastId": {
      "name": "comment_lastId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "comment_count": {
      "name": "comment_count",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "comment_publicCount": {
      "name": "comment_publicCount",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "comment_updated": {
      "name": "comment_updated",
      "type": "DATETIME",
      "readonly": false,
      "options": null
    },
    "guid": {
      "name": "guid",
      "type": "GUID",
      "readonly": 3,
      "options": null
    }
  },
  "attachments": {
    "images": {
      "name": "images",
      "extensions": ["jpg", "png"],
      "maxFileCount": 3,
      "maxFileSize": 0,
      "meta": {
        "description": {
          "name": "description",
          "default": "",
          "options": null
        }
      }
    },
    "gallery": {
      "name": "gallery",
      "extensions": ["jpg", "png"],
      "maxFileCount": 0,
      "maxFileSize": 0,
      "meta": null
    },
    "listing": {
      "name": "listing",
      "extensions": ["jpg", "png"],
      "maxFileCount": 0,
      "maxFileSize": 0,
      "meta": null
    },
    "head": {
      "name": "head",
      "extensions": ["jpg", "png", "jpeg", "gif"],
      "maxFileCount": 0,
      "maxFileSize": 512000,
      "meta": null
    },
    "podcast": {
      "name": "podcast",
      "extensions": ["mp3"],
      "maxFileCount": 1,
      "maxFileSize": 0,
      "meta": {
        "duration": {
          "name": "duration",
          "default": "0",
          "options": null
        }
      }
    }
  },
  "relations": {
    "name": "author",
    "descriptor": {
      "ghost": "Application\\Ghost\\User",
      "field": "authorId"
    },
    "type": "belongsTo"
  }
};
export default article;